/**
 * People are added with company addresses only.
 *
 * `innoctive.com` is the Google Workspace domain everyone signs in with (`cargofl.com` is only an
 * alias used for sending mail, so a Google sign-in never carries it). The admin form fixes the
 * domain beside the name box; the API refuses anything else, because an address on another
 * domain is an employee who can never sign in.
 */
export const COMPANY_EMAIL_DOMAIN = 'innoctive.com';

/**
 * What an admin means by typing a name into the box whose `@innoctive.com` is fixed: anything
 * from an "@" on is dropped (a pasted `asha@gmail.com` becomes `asha@innoctive.com`), whitespace
 * removed, and an empty name gives "" rather than a bare "@innoctive.com".
 */
export function companyEmail(typed: string, domain: string = COMPANY_EMAIL_DOMAIN): string {
  const name = (typed.split('@')[0] ?? '').replace(/\s+/g, '');
  return name ? `${name}@${domain}` : '';
}

/** Exactly one "@", a non-empty name, and the company domain — no look-alikes or subdomains. */
export function isCompanyEmail(email: string, domain: string = COMPANY_EMAIL_DOMAIN): boolean {
  const parts = email.trim().toLowerCase().split('@');
  return parts.length === 2 && parts[0]!.length > 0 && parts[1] === domain.trim().toLowerCase();
}
